import actions from '../../actionTypes';

export default zone => {
  return {
    type: actions.ADDED_ZONE,
    zone
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/zoneAdded.js